import script from "./Warning.vue?vue&type=script&setup=true&lang=ts"
export * from "./Warning.vue?vue&type=script&setup=true&lang=ts"

import "./Warning.vue?vue&type=style&index=0&id=2cf14ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf14ef6"]])

export default __exports__